import React, {Component} from "react";
import PopupClose from "../buttons/popup-close";
import ChannelItem from "../elements/channel.item";
import {type_channel} from "../../../vars/rd";

class ChannelDetail extends Component {

    constructor(props) {
        super(props);

        this.callback = props.callback;
        this.callbackLoaded = props.callbackLoaded;
        this.state = {
            data: props.data || {},
            close: false
        }
    }

    componentDidMount() {
        this.mounted = true;
        if(this.callbackLoaded) this.callbackLoaded.call(null, this);
    }

    componentWillUnmount() {
        this.mounted = false;
        this.callback = null;
        this.callbackLoaded = null;
    }

    render() {
        return (
            <div className="popup-layout">
                <h2>
                    채널 상세보기
                    <PopupClose close={this.state.close}/>
                </h2>
                <ChannelItem data={this.state.data} type={type_channel.detail} callback={this.callback} />
            </div>
        );
    }
}

export default ChannelDetail;



// WEBPACK FOOTER //
// ./src/pages/components/popup/channel.detail.jsx